import { useEffect, useRef } from 'react';

import BodyScrollLock from './BodyScrollLock';
import { UseBodyScroll } from './types';

const useLockBodyScroll: UseBodyScroll = ({ state }) => {
  const isFirstUpdate = useRef(true);

  useEffect(() => {
    return () => BodyScrollLock.cleanup();
  }, []);

  useEffect(() => {
    if ((state === 'opened' && isFirstUpdate.current) || state === 'opening') {
      BodyScrollLock.lock();
    }

    if (state === 'closed' && !isFirstUpdate.current) {
      BodyScrollLock.unlock();
    }

    if (isFirstUpdate.current) {
      isFirstUpdate.current = false;
    }
  }, [state]);
};
export default useLockBodyScroll;
